import {
    AndroidBiometryStrength,
    BiometricAuth,
} from '@aparajita/capacitor-biometric-auth';
import { isNativePlatform } from './capacitorPlatform';

export async function getBiometricAvailability() {
    if (!isNativePlatform()) {
        return {
            isNative: false,
            isAvailable: false,
            deviceIsSecure: false,
            reason: 'La biometría solo está disponible en la aplicación instalada.',
        };
    }

    const result = await BiometricAuth.checkBiometry();
    return {
        ...result,
        isNative: true,
    };
}

export async function authenticateBiometricSession() {
    const availability = await getBiometricAvailability();

    if (!availability.isAvailable && !availability.deviceIsSecure) {
        throw new Error(
            availability.reason || 'No hay biometría ni credencial de dispositivo disponible.',
        );
    }

    await BiometricAuth.authenticate({
        reason: 'Desbloqueá tu sesión de Coordinación de Visitas.',
        cancelTitle: 'Cancelar',
        allowDeviceCredential: true,
        iosFallbackTitle: 'Usar código del dispositivo',
        androidTitle: 'Desbloquear sesión',
        androidSubtitle: 'Confirmá tu identidad para continuar',
        androidConfirmationRequired: false,
        androidBiometryStrength: AndroidBiometryStrength.weak,
    });
}
